import { Box, Typography } from "@mui/material"

interface IProps {
  minWidth?: number | string
  title: string
  noContent?: string
  content?: JSX.Element[],
  slider?: JSX.Element
}

const DashboardBox = ({minWidth, title, noContent, content, slider}: IProps) => {
  return (
    <Box minWidth={minWidth} position={"relative"}>
      {slider}
      <Box p={1} sx={{backgroundColor: "#00537e", color: "white"}}>
        <Typography>{title}</Typography>
      </Box>
      {
        noContent && 
        <Box alignItems={"center"} position={"absolute"} width={"100%"} height={"100%"} sx={{backgroundColor: "rgb(0 0 0 / .6)"}} zIndex={999} display={"flex"} justifyContent={"center"}>
          <Typography variant="h5" color={"white"}>{noContent}</Typography>
        </Box>
      }
      <Box display={"flex"} justifyContent={"space-between"}>
        {
          content?.map(element => element)
        }
      </Box>
    </Box>
  )
}

export default DashboardBox